import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { analyticsAPI } from "../services/api";

export const useRouteAnalyticsSummary = (params, options = {}) => {
  return useQuery({
    queryKey: ["routeAnalytics", params],
    queryFn: () => analyticsAPI.getRouteAnalyticsSummary(params),
    enabled: !!(params?.route_signature || (params?.origin_lat && params?.origin_long && params?.dest_lat && params?.dest_long)),
    staleTime: 2 * 60 * 1000,
    cacheTime: 5 * 60 * 1000,
    ...options,
  });
};

export const useJourneyAnalytics = (legId, options = {}) => {
  return useQuery({
    queryKey: ["journeyAnalytics", legId],
    queryFn: () => analyticsAPI.getJourneyAnalytics(legId),
    enabled: !!legId,
    staleTime: 2 * 60 * 1000,
    cacheTime: 5 * 60 * 1000,
    ...options,
  });
};

export const useSimilarRoutes = (params, options = {}) => {
  return useQuery({
    queryKey: ["similarRoutes", params],
    queryFn: () => analyticsAPI.getSimilarRoutes(params),
    enabled: !!(params?.origin_lat && params?.origin_long && params?.dest_lat && params?.dest_long),
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
    ...options,
  });
};

export const useTollPlazaAnalytics = (params = {}, options = {}) => {
  return useQuery({
    queryKey: ["tollPlazas", params],
    queryFn: () => analyticsAPI.getTollPlazaAnalytics(params),
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
    ...options,
  });
};

export const useProcessJourney = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (legId) => analyticsAPI.triggerJourneyProcessing(legId),
    onSuccess: (data, legId) => {
      queryClient.invalidateQueries(["journeyAnalytics", legId]);
      queryClient.invalidateQueries(["routeAnalytics"]);
    },
  });
};

export const useClusterTollPlazas = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => analyticsAPI.triggerTollClustering(),
    onSuccess: () => {
      queryClient.invalidateQueries(["tollPlazas"]);
      queryClient.invalidateQueries(["routeAnalytics"]);
      queryClient.invalidateQueries(["journeyAnalytics"]);
    },
  });
};
